import { render, staticRenderFns } from "./BiographySection.vue?vue&type=template&id=2b37794e"
import script from "./BiographySection.vue?vue&type=script&lang=js"
export * from "./BiographySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports